import { memo, useMemo } from 'react';

import { Text } from '@bonanza-social/moonlight';
import { Trans } from '@bonanza-social/i18n';
import { formatDate } from '@bonanza-social/toolkit/utils';
import { StatusResetDisclaimerProps } from './types';

function StatusResetDisclaimer({ status }: StatusResetDisclaimerProps) {
  const { keepStatusNumberOfBoxes, expiryDate } = status;

  const transComponents = useMemo(
    () => ({
      highlight: <Text variant="caption-semi" color="darkSurfaceTertiary" />,
    }),
    [],
  );

  if (!expiryDate || !keepStatusNumberOfBoxes) {
    return null;
  }

  const date = formatDate(expiryDate, 'MMM DD, YYYY @ ha');

  return (
    <Text variant="caption" color="darkSurfaceMuted" textAlign="center">
      <Trans
        ns="status"
        i18nKey={
          keepStatusNumberOfBoxes === 1 ? 'disclaimer_one' : 'disclaimer_other'
        }
        components={transComponents}
        values={{ date, keepStatusNumberOfBoxes }}
      />
    </Text>
  );
}

export default memo(StatusResetDisclaimer);
